import React from "react";
import Container from "../ui/Container";
import Button from "../ui/Button";
import Chip from "../ui/Chip";
import { BRAND } from "../../lib/config";
import { ArrowUpRight, Shield, Cpu, HardDrive } from "lucide-react";

export default function DedicatedHero() {
  return (
    <section className="relative overflow-hidden bg-[#070A0F]">
      <div aria-hidden className="absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(34,211,238,0.16),transparent_55%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_65%,rgba(255,255,255,0.08),transparent_60%)]" />
        <div className="absolute inset-y-0 left-0 w-40 bg-gradient-to-r from-[#070A0F] to-transparent opacity-80" />
        <div className="absolute inset-y-0 right-0 w-40 bg-gradient-to-l from-[#070A0F] to-transparent opacity-80" />
      </div>

      <Container className="relative z-10">
        <div className="grid my-20 items-center py-12">
          <div className="mx-auto w-full max-w-4xl text-center">
            <div className="mb-7 flex flex-wrap items-center justify-center gap-2">
              <Chip><Shield className="h-4 w-4 text-cyan-300 mr-3" /> DDoS included</Chip>
              <Chip><Cpu className="h-4 w-4 text-cyan-300 mr-3" /> Full isolation</Chip>
              <Chip><HardDrive className="h-4 w-4 text-cyan-300 mr-3" /> NVMe storage</Chip>
            </div>

            <h1 className="text-balance text-5xl font-semibold leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-7xl">
              Dedicated servers.
              <span className="block">
                Predictable performance<span className="text-cyan-300">.</span>
              </span>
            </h1>

            <p className="mx-auto mt-6 max-w-2xl text-pretty text-base leading-7 text-white/70 sm:text-lg">
              Bare-metal hardware for serious workloads — full isolation, stable performance under load,
              and simple billing with optional prepay discounts.
            </p>

            <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Button href="#offerings" className="w-full sm:w-auto">
                View Dedicated Options <ArrowUpRight className="h-4 w-4 opacity-80" />
              </Button>
              <Button variant="secondary" href={BRAND.supportUrl} className="w-full sm:w-auto">
                Talk to Support
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}